import holidayScheduleService from '../../services/api/HolidaySchedule';
import commonFunctions from '../../mixin/common-function-mixins';
import { HOLIDAY_SCHEDULE_SUMMARY_ACTION, HOLIDAY_SCHEDULE_DELETE_ACTION, HOLIDAY_SCHEDULE_SAVE_ACTION,HOLIDAY_SCHEDULE_LOAD_BY_ID_ACTION}  from '../action-types';
import {HOLIDAY_SCHEDULE_SUMMARY_MUTATION, HOLIDAY_SCHEDULE_DATE_CHANGED_MUTATION, HOLIDAY_SCHEDULE_NOTES_CHANGED_MUTATION, 
     HOLIDAY_SCHEDULE_CLEAR_DATA_MUTATION, HOLIDAY_SCHEDULE_LOAD_BY_ID_MUTATION, HOLIDAY_SCEDULE_AUDIT_LOG_MUTATION,
     HOLIDAY_SCHEDULE_IS_DISABLE_BUTTON_MUTATION, HOLIDAY_SCHEDULE_IS_VISIBLE_MUTATION,
     HOLIDAY_SCHEDULE_AUDIT_LOG_CLEAR_OLD_DATA_MUTATION} from '../mutation-types';

export const namespaced = true;

// initial state
export const state = {
    namespaced: true,
    holidayScheduleSummaryData: [],
    holidayScheduleData: loadEmptyHolidaySchedule(),
    isVisible: false,
    isDisableButton: false,
    oldHolidayScheduleData:null
};

// actions
export const actions = {  
    async [HOLIDAY_SCHEDULE_SUMMARY_ACTION]({ commit }) {
        const response = await holidayScheduleService.getHolidayScheduleSummary();
        commit(HOLIDAY_SCHEDULE_SUMMARY_MUTATION, response.data);
        return response;
    },
    async [HOLIDAY_SCHEDULE_DELETE_ACTION]({state}, holidayId){
        var holidayEntity = {holidayId: holidayId}
        var requestData = { holidayEntity : holidayEntity, TazClientAuditLog: state.holidayScheduleData.tazClientAuditLog}
        const response = await holidayScheduleService.deleteHolidaySchedule(requestData);
        return response;
    },
    async [HOLIDAY_SCHEDULE_SAVE_ACTION] ({state}){ 
        if(!state.holidayScheduleData.tazClientAuditLog.description)
           state.holidayScheduleData.tazClientAuditLog = null;
        const response = await holidayScheduleService.saveHolidaySchedule(state.holidayScheduleData);    
        return response;
    },
    async [HOLIDAY_SCHEDULE_LOAD_BY_ID_ACTION]({ commit }, holidayId) {
        let response = await holidayScheduleService.getHolidayID(holidayId);
        commit(HOLIDAY_SCHEDULE_LOAD_BY_ID_MUTATION, response.data);
    },
}
// mutations
export const mutations = { 
    [HOLIDAY_SCHEDULE_SUMMARY_MUTATION](state, holidayScheduleSummaryData){
        holidayScheduleSummaryData.map(r =>{ r.holidayDate = commonFunctions.methods.formatDate(r.holidayDate, 'MM/DD/YYYY')}); 
        state.holidayScheduleSummaryData = holidayScheduleSummaryData;
    },
    [HOLIDAY_SCHEDULE_DATE_CHANGED_MUTATION](state, date) {
        state.holidayScheduleData.HolidayEntity.holidayDate = date;
    },
    [HOLIDAY_SCHEDULE_NOTES_CHANGED_MUTATION](state, holidayNotes) {
        state.holidayScheduleData.HolidayEntity.holidayNotes = holidayNotes;
    },
    [HOLIDAY_SCHEDULE_CLEAR_DATA_MUTATION](state){
        state.holidayScheduleData = loadEmptyHolidaySchedule();
        state.oldHolidayScheduleData = null;
    },
    [HOLIDAY_SCHEDULE_IS_DISABLE_BUTTON_MUTATION](state, value){
        state.isDisableButton = value;
    },
    [HOLIDAY_SCHEDULE_IS_VISIBLE_MUTATION](state, value){
        state.isVisible = value;
    },
    [HOLIDAY_SCHEDULE_LOAD_BY_ID_MUTATION](state, holidayScheduleData) {
        state.oldHolidayScheduleData =  JSON.parse(JSON.stringify(holidayScheduleData));
        state.holidayScheduleData.HolidayEntity = holidayScheduleData;
    },
    [HOLIDAY_SCEDULE_AUDIT_LOG_MUTATION](state, payLoad){
        state.holidayScheduleData.tazClientAuditLog = payLoad
    },
    [HOLIDAY_SCHEDULE_AUDIT_LOG_CLEAR_OLD_DATA_MUTATION](state){
        state.oldHolidayScheduleData = null
    }
}


function loadEmptyHolidaySchedule() {
    return{
            HolidayEntity : {
            holidayId: 0,
            holidayDate: null,
            holidayNotes: ""
        }
    }
}